import React from "react";
import { Linkedin, Mail } from "lucide-react";
import { FadeUp, GoldLineDraw } from "@/components/motion/Reveal";

const TEAM = [
  {
    name: "Nomvula Sibanda",
    role: "Founder & CEO",
    country: "🇿🇼",
    bio: "Third-generation Zimbabwean builder, 15 years across UK residential finance and Southern African property development. Founded MAVULA to give the diaspora a dignified path home.",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=600&q=80",
  },
  {
    name: "Kagiso Mokoena",
    role: "Co-Founder & COO",
    country: "🇧🇼",
    bio: "Former African Development Bank housing analyst. Leads project execution across Botswana, Namibia, and South Africa.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80",
  },
  {
    name: "Chipo Nyathi",
    role: "Head of Compliance",
    country: "🇿🇼",
    bio: "Property lawyer (LLB Wits, LLM UCL) — protects members' interests via independent conveyancers and title verification in every jurisdiction we serve.",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=600&q=80",
  },
  {
    name: "Themba Ncube",
    role: "Head of Investor Relations",
    country: "🇿🇦",
    bio: "20 years in African capital markets. Manages our investor programmes and government partnerships.",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=600&q=80",
  },
];

export default function TeamPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20" data-testid="team-page">
      <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ The Team</span></div>
      <h1 className="font-display text-3xl md:text-4xl lg:text-5xl mv-green-text mt-3 leading-tight">
        The people behind <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>your open door.</span>
      </h1>
      <p className="mt-4 text-[15px] max-w-2xl" style={{ color: "var(--mv-muted)" }}>
        We are Africans building for Africans — with the discipline of UK finance and the heart of home.
      </p>
      <GoldLineDraw className="mt-6 w-14" />

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
        {TEAM.map((m, i) => (
          <FadeUp key={m.name} delay={i * 0.08}>
            <div className="mv-card overflow-hidden flex flex-col md:flex-row h-full">
              <div className="md:w-1/3 h-64 md:h-auto overflow-hidden">
                <img src={m.image} alt={m.name} loading="lazy" className="w-full h-full object-cover" />
              </div>
              <div className="p-5 md:p-6 flex-1">
                <div className="flex items-center gap-2">
                  <span className="text-lg">{m.country}</span>
                  <span className="text-[11px] tracking-[0.24em] uppercase" style={{ color: "var(--mv-muted)" }}>{m.role}</span>
                </div>
                <h3 className="font-display text-xl mv-green-text mt-1">{m.name}</h3>
                <p className="mt-3 text-[14px] leading-relaxed" style={{ color: "var(--mv-muted)" }}>{m.bio}</p>
                <div className="mt-4 flex gap-2 text-neutral-500">
                  <Linkedin size={16} />
                  <Mail size={16} />
                </div>
              </div>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  );
}
